import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import PageSkeleton from '../../components/PageSkeleton';
import LoadingPageError from '../../components/LoadingPageError';
const PublicCoursePageLoadable = Loadable({
  loader: () => import( /* webpackChunkName: "PublicCoursePage" */'../PublicCoursePage'),
  LoadingComponent: PageSkeleton,
  ErrorComponent: LoadingPageError
});
export default PublicCoursePageLoadable;